import React, { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { FiAlertCircle } from 'react-icons/fi'

const RejectApproval = ({ show, close, title, reject, isLoading }) => {

    const [reason, setReason] = useState("");

    const handleReject = () => {
        reject({ rejectionRemark: reason });
    }


    return (
        <Modal show={show} onHide={close} centered >
            <div className='common-modal'>
                <Modal.Header className="flex-column align-items-start gap-3 w-auto border-none">
                    <div className="text-center">
                        <div className="common-modal__icon-wrapper mb-0">
                            <FiAlertCircle className="common-modal__lock-icon" />
                        </div>
                    </div>
                    <h6 className="">{title}</h6>
                    <p className="common-modal__subtitle mb-0">
                        Please provide your comments/remarks
                    </p>
                </Modal.Header>
                <Modal.Body className="w-auto  border-none">
                    <Form>
                        <Form.Group className="" controlId="reason">
                            <Form.Control
                                as="textarea"
                                rows={3}
                                onChange={(e) => setReason(e.target.value)}
                                value={reason}
                                placeholder="Type here..."
                                className='textarea-box'
                            />
                        </Form.Group>
                    </Form>
                    {/* <p className=" my-2">
                        A request will be sent to the super admin
                    </p> */}
                </Modal.Body>

                <div className="d-flex justify-content-between p-4 pt-0">
                    <Button
                        variant="outline-secondary"
                        className=" w-50  m-2"
                        onClick={close}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        className=" w-50  m-2"
                        onClick={handleReject}
                    >
                        {isLoading && <Spinner size='sm' />}  Confirm
                    </Button>
                </div>
            </div>
        </Modal>
    )
}




export default RejectApproval
